module.exports = __webpack_public_path__ + "img/philips_shape_digital_98x51.a48fe556.svg";